import React, {useState,  useEffect } from 'react';
import DeckGL from 'deck.gl';


import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { _GeoJSONLoader as GeoJSONLoader } from "@loaders.gl/json";

import zipLoader from './zipLoader'


import { renderLayers } from "./RenderLayers";

// 初期ビューポートの設定
const INITIAL_VIEW_STATE = {
    latitude: 30.90222470517144,
    longitude: 16.169500999932342,
    bearing: 0,
    pitch: 70,
    maxPich:80,
    zoom: 1
};

const groupBy = (array, getKey) =>
    array.reduce((obj, cur, idx, src) => {
        const key = getKey(cur, idx, src);
        (obj[key] || (obj[key] = [])).push(cur);
        return obj;
    }, {});

function Map() {
    const [data, setData] = useState(null)
    const [viwState, setViewState] = useState(INITIAL_VIEW_STATE);
    const [selectedValue, setSelectedValue] = useState("on");


    useEffect(() => {
        const loadData = async () => {
            const res = await zipLoader("./data/countries-s.zip", GeoJSONLoader, (d) => {
                //console.log(d) //ローディング処理
            })

            const ammypower = await fetch('./data/ammypower.json', { method: 'GET' })
                .then(res => res.json())
                .then(data => { return data})
            
            const coutryAmmyPoewer = groupBy(ammypower, d => d.countryLongName);

            res.features.forEach(d=>{
                const key = d.properties.NAME_LONG;
                if (coutryAmmyPoewer[key])  d.properties  = Object.assign(d.properties, coutryAmmyPoewer[key][0])
            })

            setData(res)
        }

        loadData()

    }, [])


    //ツールチップを生成する
    const tooltipHandler = (d) => {
        if (!d || !d.object) return null;
        let obj = d.object;

        if (d.object.properties) obj = d.object.properties;

        const html = `
        <center>${obj.NAME}</center>
        <table>
            <tr><th>PowerIndex</th><td>${obj.pwrIndxContainer}</td></tr>
        </table>`

        return {
            // tooltip内に出力するhtml要素を渡す
            html: html,
            // tooltip内のhtmlに適用するstyleを設定する
            style: {
                lineHight:"1em",
                backgroundColor:"white",
                color:"black",
                fontSize: "0.8em",
                fontFamily:'"Mohave", sans-serif',
                marginTop: "-5em",
                marginLeft: "-2.3em"
            }
        };
    };

    const controlProps = (item) => ({
        checked: selectedValue === item,
        onChange: handleChange,
        value: item,
        name: 'size-radio-button-demo',
        inputProps: { 'aria-label': item },
    });

    const handleChange = (event) => {
        setSelectedValue(event.target.value);
    };

    return (
        <div>
            <DeckGL
                initialViewState={viwState}
                controller={true}
                layers={renderLayers({ data, selectedValue })}
                getTooltip={tooltipHandler}
                //onViewStateChange={(v)=>console.log(v.viewState)}
            >
            </DeckGL>
            <div id="window">
                <fieldset id="info">
                    <legend>2023 Military Strength</legend>
                    <p>Elevation = Firepower</p>
                    <p style={{ fontSize: "0.6em" }}>* Lower PwrIndx, more powerful a nation's military.</p>
                </fieldset>
                <fieldset id="ui">
                    <legend>COORDINATE SYSTEM</legend>
                    <FormControl>
                        <RadioGroup
                            row
                            sx={{
                                '& .MuiTypography-root': {
                                    fontFamily: '"Mohave", sans-serif',
                                    fontSize:12
                                },
                                '& .MuiSvgIcon-root': {
                                    fontSize: 12,
                                },                                
                            }}
                            aria-labelledby="demo-controlled-radio-buttons-group"
                            name="controlled-radio-buttons-group"
                            value={selectedValue}
                            onChange={handleChange}
                        >
                            <FormControlLabel value={"on"} control={<Radio />} label="METER OFFSETS" />
                            <FormControlLabel value={"off"} control={<Radio />} label="LNGLAT" />
                        </RadioGroup>
                    </FormControl>
                </fieldset>
            </div>
            
            <div className="attribution">
                source：<a
                    href="https://www.globalfirepower.com/countries-listing.php"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                © globalfirepower.com
                </a>
            </div>
        </div>
    );
}

export default Map;